import styled from 'styled-components';
import { getInvertedColor } from '@elfsight/widget-utils';

type UserLocationProps = {
  color?: string;
};

export const UserLocation = ({ color = '#111' }: UserLocationProps) => {
  const invertedColor = getInvertedColor(color);

  return (
    <MarkerBody
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 185 184"
      fill="none"
    >
      <circle
        cx="92.4991"
        cy="92.0001"
        r="91.4406"
        fill={color}
        fillOpacity="0.1"
      />
      <g filter="url(#filter0_d_4563_18892)">
        <circle cx="92.5" cy="91.9998" r="12" fill={invertedColor} />
      </g>
      <circle cx="92.5" cy="91.9998" r="9" fill={color} />
      <defs>
        <filter
          id="filter0_d_4563_18892"
          x="78.5"
          y="77.9998"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4563_18892"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4563_18892"
            result="shape"
          />
        </filter>
      </defs>
    </MarkerBody>
  );
};

const MarkerBody = styled.svg`
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 184px;
  height: 184px;
`;
